<template>
  <div v-if="visible" class="stella-more-wrapper">
    <!-- Backdrop Overlay -->
    <div class="stella-more-backdrop" @click="close()"></div>

    <!-- Bottom Sheet Container -->
    <div class="stella-more-sheet animate-slide-up" role="dialog" aria-modal="true">
      <!-- Drag / Pull Indicator Handle -->
      <div class="stella-sheet-handle-wrapper" @click="close()">
        <div class="stella-sheet-handle"></div>
      </div>

      <!-- Header -->
      <div class="d-flex align-items-center justify-content-between px-4 pb-2">
        <h5 class="m-0 font-size-16 font-weight-bold text-white">More Options</h5>
        <button type="button" class="stella-close-btn" @click="close()" aria-label="Close">
          <i class="fa fa-times text-white-50"></i>
        </button>
      </div>

      <!-- Item List -->
      <div class="stella-more-list px-2 py-2">
        <button
          v-for="(item, index) in items"
          :key="index"
          type="button"
          class="stella-more-item d-flex align-items-center justify-content-between w-100 px-3 py-2 mb-1"
          @click="selectItem(item)"
        >
          <div class="d-flex align-items-center">
            <div class="stella-more-item-icon me-3">
              <component :is="item.icon" class="stella-icon" />
            </div>
            <span class="font-size-14 text-white font-weight-500">{{ item.name }}</span>
          </div>
          <i class="fa fa-chevron-right font-size-12 text-white-50"></i>
        </button>

        <!-- Divider -->
        <div class="stella-more-divider my-2"></div>

        <!-- Logout Action -->
        <button
          type="button"
          class="stella-more-item stella-logout-item d-flex align-items-center justify-content-between w-100 px-3 py-2"
          @click="handleLogout()"
        >
          <div class="d-flex align-items-center">
            <div class="stella-more-item-icon me-3 text-danger">
              <icon-logout class="stella-icon" />
            </div>
            <span class="font-size-14 text-danger font-weight-500">Log Out</span>
          </div>
          <i class="fa fa-sign-out font-size-14 text-danger opacity-75"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  IconSettings,
  IconBilling,
  IconTransactions,
  IconHelp,
  IconLogout,
  IconProfile,
  IconRequests
} from './icons';
import { cleanUpAfterLogout } from "@/common/login-service";
import { mapActions } from 'vuex';

export default {
  name: "MoreMenu",
  components: {
    IconSettings,
    IconBilling,
    IconTransactions,
    IconHelp,
    IconLogout,
    IconProfile,
    IconRequests
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapActions(['setInvitee', 'setMessage']),
    close() {
      this.$emit('close');
    },
    selectItem(item) {
      this.close();
      if (item.route) {
        const target = { name: item.route };
        if (item.params) target.params = item.params;
        if (item.query) target.query = item.query;

        this.$router.push(target).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }
    },
    handleLogout() {
      this.close();
      this.setInvitee(null);
      cleanUpAfterLogout();
      localStorage.clear();
      this.setMessage('Successfully logged out.');
      if (this.$route.name !== 'HomePage') {
        this.$router.replace({ name: 'HomePage' });
      }
    }
  }
}
</script>

<style scoped>
.stella-more-wrapper {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.stella-more-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: fadeIn 0.25s ease-out;
}

.stella-more-sheet {
  position: relative;
  z-index: 1061;
  background: rgba(18, 18, 22, 0.96);
  backdrop-filter: blur(28px);
  -webkit-backdrop-filter: blur(28px);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.6);
  padding: 8px 8px calc(16px + env(safe-area-inset-bottom, 0px)) 8px;
  max-height: 80vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.stella-sheet-handle-wrapper {
  padding: 6px 0 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.stella-sheet-handle {
  width: 38px;
  height: 4px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.22);
}

.stella-close-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  transition: background 0.2s ease;
}

.stella-close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.stella-more-item {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 14px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.stella-more-item:hover, .stella-more-item:active {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.08);
}

.stella-more-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.stella-more-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 8px 12px;
}

.stella-logout-item:hover, .stella-logout-item:active {
  background: rgba(255, 77, 79, 0.12);
  border-color: rgba(255, 77, 79, 0.2);
}

.animate-slide-up {
  animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
